let overlayReady = false

function ensureOverlay() {
  if (overlayReady) return
  if (document.getElementById("admissao-overlay")) {
    overlayReady = true
    return
  }

  const div = document.createElement("div")
  div.id = "admissao-overlay"
  div.style.display = "none"
  div.style.position = "fixed"
  div.style.inset = "0"
  div.style.zIndex = "9999"
  div.style.background = "rgba(255,255,255,.75)"

  div.innerHTML = `
    <div style="position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
                background:#fff; border:1px solid #e5e7eb; border-radius:12px;
                padding:18px 22px; box-shadow:0 10px 25px rgba(0,0,0,.10);
                min-width:320px; text-align:center;">
      <div style="font-size:18px; font-weight:700; color:#111827; margin-bottom:6px;">
        Consultando dados...
      </div>
      <div style="font-size:13px; color:#6b7280; margin-bottom:14px;">
        Aguarde enquanto buscamos as informações do candidato.
      </div>
      <div style="font-size:26px;">⏳</div>
    </div>
  `

  document.body.appendChild(div)
  overlayReady = true
}

export function lockScreen(lock) {
  ensureOverlay()
  const el = document.getElementById("admissao-overlay")
  if (!el) return

  if (lock) {
    el.style.display = "block"
    document.body.style.overflow = "hidden"
  } else {
    el.style.display = "none"
    document.body.style.overflow = ""
  }
}
